import React, { useState } from 'react';
import axios from 'axios'
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    FormGroup,
    Label,
    Input,
    NavLink,
    Alert
} from 'reactstrap'
import { Navigate } from 'react-router-dom'


const LoginModal = props => {
    const [modal, setModal] = useState()
    const [redirect, setRedirect] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')

    // To Redirect to the home page when login 2 paths in which causes an error
    if(redirect){
        return <Navigate replace to='/' state={{ requireRefresh: true }} />
    }

    // Function to open and close login modal
    const toggle = () => {
        setModal(!modal)
    }

    // Login Function
    const submitLogin = async e => {
        e.preventDefault()
        const loginDetails = {
            email,
            password
        }
        await axios.post('api/auth',loginDetails)
        .then(res => {
            toggle()
            localStorage.setItem('token', res.data.token)
            props.setAuthenticated(true)
        })
        .catch(err => {
            localStorage.clear()
            if (err.response.status === 404 && err.response.data.message !== "Email not found"){
                setRedirect(true)
            }
            setErrorMessage(err.response.data.message)
            
        })
    }
    
    return (
        <div>
            <NavLink
                className={props.triggerClassName || 'auth-nav-link auth-nav-link--secondary'}
                onClick={toggle}
                href="#"
            >
                {props.label || 'Login'}
            </NavLink>

            <Modal
                className='fobk-modal'
                isOpen={modal}
                toggle={toggle}
            >
                <ModalHeader
                    toggle={toggle}
                >
                    Login
                </ModalHeader>
                <ModalBody>
                    <p>Sign in to manage your registrations, profile details, and upcoming FoBK activities.</p>
                    {errorMessage&& <Alert color="danger">{ errorMessage }</Alert>}
                    <Form onSubmit={submitLogin}>
                        <FormGroup>
                            <Label>Email</Label>
                            <Input 
                                type="email"
                                defaultValue={email}
                                placeholder="Email"
                                onChange={e => setEmail(e.target.value)}
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for = "password" >Password</Label>
                            <Input 
                                type="password"
                                placeholder="Password"
                                defaultValue={password}
                                onChange={e => setPassword(e.target.value)}
                                required
                            />
                        </FormGroup>
                        <a href="/resetpassword">Forgot Password?</a>
                        <Button
                            color="primary"
                            className='w-100 mt-4'
                            block
                        >
                            Login
                        </Button>
                    </Form>
                </ModalBody>
            </Modal>
        </div>
    )
}

export default LoginModal
